import { BASE_PATH_API } from 'constants/env';
import { TIMEOUT_TIME } from 'constants/general';
import axios from 'axios';

export async function postRegister ({raw} = {}){
    const apiURL = BASE_PATH_API + '/app/ApiRest/Registro'
    //console.log(JSON.stringify(data))

    const config = {
        method: 'post',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        mode: 'no-cors',
		crossdomain: true,
        headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json; charset=utf-8'
        },
        data: raw
    };


    return await axios(config)
    .then(res => {
        const {
            //config,
            //headers, 
            //status, 
            data
        } = res
        //console.log(res)
        // console.log(config)
        //console.log(data)
        // console.log(headers)
        // console.log(status)
        return data
    })
    .catch(error =>{
        console.log(error.request.status)
        if(error.message === 'Network Error'){
            console.log('Error de conexión')
        }
        else if(error.request){
            console.log(error.request.responseText)
        }
        if(error.request.status === 0) {
            console.log('request 0')
        }else{
            if(error.response.status === 401) {
                //console.log(error.response.data.metadata.message)
                //return error.response.data.metadata
                console.log(error.response.data.msg)
                return {error: error.response.status, message: error.response.data.msg }
            }
            else if(error.response.status === 404) {
                console.error(error.response);
                console.log('request 404')
            }
            else if(error.response.status === 440) {
                console.log('request 440')
            }
            else if(error.response.status === 500) {
                console.error(error.response);
                console.log('request 500')
            }
            else{
                console.error(error.response.status);
                console.error(error.response);
            }
        }
    })


    // const property = {
    //     method: 'POST',
    //     mode: 'cors', 
    //     cache: 'default', 
    //     body: JSON.stringify(data),
    //     headers: {
    //         "Content-Type": "application/json"
    //     }
    // }

    // return fetch(apiURL, property)
    // .then(res => res.json())
    // .then(response =>{
    //     console.log(response)
    //     return {
    //         response
    //     }
    // })
    // .catch(error => console.log('error', error))
}
